import React, { useState } from "react";
import { toast } from "react-toastify";
import "../../pages/user/css/Social.css";
import { API_ciudadanos } from "../../config/apiConfig";

const CitaERACIS = ({ onClose, datosUsuario = {}, servicio = "Servicios Sociales" }) => {
  
  // Campos del formulario
  const [subject, setSubject] = useState("");
  const [miembros, setMiembros] = useState("1");
  const [menoresACargo, setMenoresACargo] = useState("");
  const [situacion, setSituacion] = useState([]);
  
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);

  // Toggle situación
  const toggleSituacion = (label) => {
    setSituacion((prev) =>
      prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label]
    );
  };

  // POST helper (local)
  const postCita = async (payload) => {
    try {
      const res = await fetch(
        `${API_ciudadanos}/${payload.userId}/citas`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) throw new Error("Error al registrar cita");
      return true;
    } catch (err) {
      console.error(err);
      setErrorMessage("Ha ocurrido un error. Inténtalo de nuevo.");
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    // Validaciones
    if (!subject.trim() || !miembros || !menoresACargo || situacion.length === 0) {
      toast.warn("Por favor, rellena todos los campos.");
      return;
    }

    const ok = await postCita({
      serviciosSociales: {
        nMiembrosFamilia: parseInt(miembros, 10),
        menoresACargo: menoresACargo === "sí",
        situacionSocial: situacion.join(", "),
      },
      userId: datosUsuario.userId,
      subject: subject.trim(),
      technicianId: null,
      appointmentDate: null,
      responseMessage: "",
      isResponseRead: false,
      state: "Pendiente",
      name: `${datosUsuario.name} ${datosUsuario.lastName || ""}`.trim(),
      email: datosUsuario.email,
      phone: datosUsuario.phone || "",
      address: datosUsuario.address || "",
      service: servicio,
      dni: datosUsuario.dni || "",
    });

    if (!ok) return;

    setSuccessMessage(true);
    setTimeout(onClose, 1700);
  };

  return (
    <div className="cita-social column">

      <div className="between modal-header">
        <h2 className="titulo-user align-center mayusculas blanco flex-center">SOLICITAR CITA </h2>
        <button className="close-button" onClick={onClose}>✖</button>
      </div>

      <form onSubmit={handleSubmit} className="column gap-20">
        {/* Asunto */}
        <div className="column gap-5">
          <label className="verde mayusculas bold">Asunto:</label>
          <textarea
            className="campo"
            placeholder="Asunto de la cita"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
        </div>

        {/* Nº miembros unidad familiar */}
        <div className="align-center gap-20">
          <label className="verde mayusculas bold">Número de miembros en la unidad familiar *</label>
          <input
            type="number"
            className="w-40 campo"
            min="1"
            value={miembros}
            onChange={(e) => setMiembros(e.target.value)}
            required
          />
        </div>

        {/* Menores a cargo */}
        <div className="align-center gap-20">
          <label className="verde mayusculas bold">¿Hay menores a cargo? *</label>
          <div className="flex gap-20">
          {[
              { label: "Sí", value: "sí" },
              { label: "No", value: "no" },
            ].map((opt) => (
              <label key={opt.value} className="align-center gap-5">
                <input
                  type="radio"
                  name="menores"
                  value={opt.value}
                  checked={menoresACargo === opt.value}
                  onChange={(e) => setMenoresACargo(e.target.value)}
                />
                {opt.label}
              </label>
            ))}
          </div>
        </div>

        {/* Situación actual */}
        <div className="column">
          <label className="verde mayusculas bold">Situación actual *</label>
          {[
            "Problemas socioeconómicos",
            "Problemas de vivienda",
            "Situación de discapacidad o dependencia",
            "Problemas sociofamiliares",
          ].map((label) => (
            <label key={label}  className="align-center gap-5">
              <input
                type="checkbox"
                value={label}
                checked={situacion.includes(label)}
                onChange={() => toggleSituacion(label)}
              />
              {label}
            </label>
          ))}
        </div>

        <p>* Las citas se asignarán por orden de llegada y urgencia. Revisa los datos facilitados.</p>

        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && (
          <div className="historico-seguimiento">
            <div className="modal-content mensaje-exito verde mb-20">
              <p>Cita solicitada con éxito.<br /> Uno de nuestros técnicos se pondrá en contacto contigo lo antes posible.</p>
            </div>
          </div>
        )}

        <button type="submit" className="verde fondo-blanco boton">Pedir cita</button>
      </form>
    </div>
  );
};

export default CitaERACIS;
